<template>
  <div class="site-over-view">
    <div class="site-over-view-line" style="margin: 40px 0;padding: 0 40px;">
      <div class="site-person-count-box" style="background:linear-gradient(#12C9E4, #12C9E499);">
        <i class="el-icon-damai-airudiantubiaohuizhi-zhuanqu_changdiyuding"></i>
        <div class="site-person-count-box-info">
          <div class="site-person-count">{{venueDeviceCount}}</div>
          <div class="site-person-tip">场地数量</div>
        </div>
      </div>
      <div class="site-person-count-box" style="background:linear-gradient(#ED7D31, #ED7D3199);">
        <i class="el-icon-damai-yuyue1"></i>
        <div class="site-person-count-box-info">
          <div class="site-person-count">{{bookingCount}}</div>
          <div class="site-person-tip">总预约人数</div>
        </div>
      </div>
      <div class="site-person-count-box" style="background:linear-gradient(#92D050, #92D05099);">
        <i class="el-icon-damai-yingshoujine"></i>
        <div class="site-person-count-box-info">
          <div class="site-person-count">{{totalMoney}}</div>
          <div class="site-person-tip">总收入</div>
        </div>
      </div>
    </div>

    <div class="site-over-view-line" style="height: 300px;margin: 30px 0 20px 0;padding: 10px;position: relative;border: 1px solid #DCDFE6;box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);">
      <chart-time-select @getData="getVenuePlaceBookingRecordStatictics" />
      <common-line style="z-index: 1000" lineId='siteRegisterRecordLine' :height='"280px"' :lineTitle='siteRegisterRecordTitle' :legendData="siteRegisterRecordLegendData" :xAxis="siteRegisterRecordXAxis" :yAxis='siteRegisterRecordYAxis' :series='siteRegisterRecordSeries' />
    </div>

    <div class="finance-over-view-line" style="height: 300px;margin: 50px 0 20px 0;padding: 10px;position: relative;border: 1px solid #DCDFE6;box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);">
      <chart-time-select @getData="getVenueConsumptionRecordStatictics" />
      <common-line style="z-index: 1000" lineId='siteConsumptionRecordLine' :height='"280px"' :lineTitle='siteConsumptionRecordTitle' :legendData="siteConsumptionRecordLegendData" :xAxis="siteConsumptionRecordXAxis" :yAxis='siteConsumptionRecordYAxis' :series='siteConsumptionRecordSeries' />
    </div>
  </div>
</template>

<script>
  import CommonLine from '../../../components/Echarts/Line/commonLine'
  import {api} from '../../api/SiteReservation'
  import {errorHandler} from '../../../utils/errorHandler'
  import ChartTimeSelect from "../../../components/Echarts/ChartTimeSelect/ChartTimeSelect";

  export default {
    components: {ChartTimeSelect, CommonLine},
    name: 'site-over-view',
    data () {
      return {
        venueDeviceCount: 0,
        bookingCount: 0,
        totalMoney: 0,

        siteRegisterRecordRadio: false,
        siteRegisterRecordTitle: '预约统计',
        siteRegisterRecordLegendData: [],
        siteRegisterRecordXAxis: {
          type: 'category',
          name: '日期',
          data: []
        },
        siteRegisterRecordYAxis: [
          {
            type: 'value',
            name: '次数',
            splitLine: {
              show: false
            },
          }
        ],
        siteRegisterRecordSeries: [],

        siteConsumptionRecordRadio: false,
        siteConsumptionRecordTitle: '缴费统计',
        siteConsumptionRecordLegendData: [],
        siteConsumptionRecordXAxis: {
          type: 'category',
          name: '日期',
          data: []
        },
        siteConsumptionRecordYAxis: [
          {
            type: 'value',
            name: '次数',
            splitLine: {
              show: false
            },
          }
        ],
        siteConsumptionRecordSeries: [],
      }
    },
    mounted () {
      this.getVenueOverview()
    },
    methods: {
      getVenueOverview () {
        this.$axios.get(api.getVenueOverview, {})
          .then(res => {
            let data = res.data.data
            this.venueDeviceCount = data.venueDeviceCount
            this.bookingCount = data.bookingCount
            this.totalMoney = data.totalMoney
          })
          .catch(errorHandler('获取数据失败'))
      },

      getVenuePlaceBookingRecordStatictics (type, startTime, endTime) {
        this.$axios.post(`${api.getVenuePlaceBookingRecordStatictics}`, {
          startTime: startTime || '',
          endTime: endTime || '',
          timeType: type || 'DAY'
        })
          .then(res => {
            let data = res.data.data
            let xData = []
            let seriesData = []
            data.map(v => {
              seriesData.push(v.count)
              if (type === 1) {
                let dateArr = v.date.split('-')
                let showData = `${dateArr[1]}-${dateArr[2]}`
                xData.push(showData)
              } else {
                xData.push(v.date)
              }
            })
            this.siteRegisterRecordXAxis.data = xData
            this.siteRegisterRecordSeries = [
              {
                name: '',
                type: 'line',
                stack: '统计',
                // areaStyle: {},
                smooth:true,
                symbol: 'circle',
                symbolSize: 5,
                sampling: 'average',
                itemStyle: {
                  color: '#00A0E6'
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#00A0E6'
                  }, {
                    offset: 1,
                    color: '#ffe'
                  }])
                },
                data: seriesData
              },
            ]
          })
          .catch(errorHandler('获取数据失败'))
      },

      getVenueConsumptionRecordStatictics (type, startTime, endTime) {
        this.$axios.post(`${api.getVenueConsumptionRecordStatictics}`, {
          startTime: startTime || '',
          endTime: endTime || '',
          timeType: type || 'DAY'
        })
          .then(res => {
            let data = res.data.data
            let xData = []
            let seriesData = []
            data.map(v => {
              seriesData.push(v.count)
              if (type === 1) {
                let dateArr = v.date.split('-')
                let showData = `${dateArr[1]}-${dateArr[2]}`
                xData.push(showData)
              } else {
                xData.push(v.date)
              }
            })
            this.siteConsumptionRecordXAxis.data = xData
            this.siteConsumptionRecordSeries = [
              {
                name: '',
                type: 'line',
                stack: '统计',
                // areaStyle: {},
                smooth:true,
                symbol: 'circle',
                symbolSize: 5,
                sampling: 'average',
                itemStyle: {
                  color: '#00A0E6'
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#00A0E6'
                  }, {
                    offset: 1,
                    color: '#ffe'
                  }])
                },
                data: seriesData
              },
            ]
          })
          .catch(errorHandler('获取数据失败'))
      }
    },

    watch: {}
  }
</script>

<style lang="less">
  .site-over-view {
    padding: 10px 2%;
    .site-over-view-line {
      display: flex;
      justify-content: space-between;
      .site-person-count-box {
        width: 30%;
        height: 160px;
        padding: 10px 10px;
        border-radius: 10px;
        color: #ffffff;
        background-color: #00A0E6;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid #DCDFE6;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
        i {
          width: 30%;
          font-size: 48px;
        }
        .site-person-count-box-info {
          width: 70%;
          text-align: left;
          .site-person-count {
            font-size: 36px;
            font-weight: 600;
            word-wrap:break-word;
          }
          .site-person-tip {
            font-size: 16px;
          }
        }
      }
      .site-over-view-line-left {
        width: 49%;
        padding: 10px 10px;
        border: 1px solid #eeeeee;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        overflow: hidden;
      }
      .site-over-view-line-right {
        width: 49%;
        padding: 10px 10px;
        border: 1px solid #eeeeee;
        border-radius: 10px;
        overflow: hidden;
      }

      .el-table {
        thead {
          th {
            padding: 6px 0;
            text-align: center;
            color: #666666;
            background-color: #eff1f5;
          }
        }
        tbody {
          td {
            padding: 6px 0;
            text-align: center;
            color: #FF0000;
          }
        }
      }

      .el-pagination {
        padding: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/SiteReservation/SiteOverView/SiteOverView.vue